class TokenizedWeeklyPicksExceptionController {
    constructor($window) {
        this.$window = $window;
    }

    reload() {
        this.$window.location.reload();
    }
}

const tokenizedWeeklyPicksExceptionComponentDefinition = {
    controller: ['$window', TokenizedWeeklyPicksExceptionController],
    template: require('./tokenized-weekly-picks-exception.component.html').trim(),
};

module.exports = {
    TokenizedWeeklyPicksExceptionController,
    tokenizedWeeklyPicksExceptionComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/browse/tokenized-weekly-picks-exception.component.js